export default __webpack_public_path__ + "static/sala-de-aula-5cbbe749e6486696dc10d495124eccd4.png";